import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { PostEditor } from "@/components/admin/PostEditor";

export const Route = createFileRoute("/admin/posts_/new")({
  component: NewPostPage,
  head: () => ({ meta: [{ title: "Add New Post — Admin" }, { name: "robots", content: "noindex" }] }),
});

function NewPostPage() {
  return (
    <AdminLayout title="Add New Post">
      <PostEditor />
    </AdminLayout>
  );
}
